<template>
    <card class="spaced typo">
        
        <h2 class="text-white mb-4">
            {{ $t('xapi.common.agents') }}
        </h2>

        <form @submit.prevent @keydown="filters.errors.clear($event.target.name)">

            <div class="form-row">

                <label class="col-md-1 col-form-label text-md-right text-left pb-0">
                    {{ $t('xapi.common.id') }}
                </label>

                <base-input class="col-md-11"
                    :placeholder="$t('xapi.statements.search.actor-placeholder')"
                    v-model="filters.id"
                    name="id"
                    :error="filters.errors.get('id')">
                </base-input>
            </div>

            <div class="form-row">

                <label class="col-md-1 col-form-label text-md-right text-left pb-0">
                    {{ $t('xapi.common.type') }}
                </label>

                <base-select class="col-md-11 mb-2"
                    :placeholder="$t('xapi.common.type')"
                    v-model="filters.objectType"
                    :options="filters.options.objectType"
                    clearable>
                </base-select>
            </div>

            <div class="form-row">

                <label class="col-md-1 col-form-label text-md-right text-left pb-0">
                    {{ $t('xapi.common.name') }}
                </label>

                <base-input class="col-md-11"
                    :placeholder="$t('xapi.common.search.name-placeholder')"
                    v-model="filters.name"
                    name="name"
                    :error="filters.errors.get('name')">
                </base-input>
            </div>

            <div class="text-center pt-1">
                <base-button type="primary" native-type="submit" @click="apply">
                    {{ $t('common.apply') }}
                </base-button>

                <base-button type="primary" native-type="submit" link @click="reset">
                    {{ $t('common.reset') }}
                </base-button>
            </div>

        </form>
    </card>
</template>

<script>
    export default {

        props: {
            scope: {
                type: String,
                default: null
            }
        },

        data() {
            return {
                loader: this.$xapi.loaders.agents,
                filters: this.$xapi.filters.agents,
            }
        },

        created() {
            this.$xapi.filters.agents.attach(this, this.scope)
        },

        methods: {

            apply() {
                this.loader.firstLoad()
            },

            reset() {
                this.filters.reset()
                this.loader.firstLoad()
            }
        }
    }
</script>
